import type { FC } from 'react';
import React, { Fragment } from 'react';

import { LoadableAfterPaint, LoadableHydrateOnHover } from '@confluence/loadable';
import { getSSRFeatureFlag } from '@confluence/ssr-utilities';

import type { PageTreeProps } from './PageTree';
export { ConditionalTreeItemTooltip } from './ConditionalTreeItemTooltip';
export { getI18nMessageForKnownError } from './movePublishedPageErrorHelpers';
import { PAGE_TREE_QUERY_BEST_EFFORT_TASK_NAME } from './preloadPageTree';

export type { ContentTreeItem } from './data-transformers';

export const ANIMATE_TIME_SEC = 2;
const DELAY_HYRATION_ON_HOVER_FF = 'confluence.ssr.delay.hydration.on.hover';

export const PageTreeLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageTree" */ './PageTree')).PageTree,
});

export const PageTreeLoaderOnHover = LoadableHydrateOnHover({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageTreeOnHover" */ './PageTree')).PageTree,
	hydrateImmediately: () =>
		window?.__SSR_QUERY_TIMEOUTS__?.bestEffortTimeouts?.[PAGE_TREE_QUERY_BEST_EFFORT_TASK_NAME],
});

export const PageTree: FC<PageTreeProps> = (props) => {
	const delayingHydrationOnHoverConfig = getSSRFeatureFlag(DELAY_HYRATION_ON_HOVER_FF) || {};
	return (
		<Fragment>
			{delayingHydrationOnHoverConfig.enabled ? (
				<PageTreeLoaderOnHover {...props} />
			) : (
				<PageTreeLoader {...props} />
			)}
		</Fragment>
	);
};
